import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { getLeadEventsForDay } from '../../../graph-ql/calendar/plan-days.queries';
import { createEvent, createEventWithoutUser, removeEvent } from '../../../graph-ql/mutations';
import { getLeadEvents, getLeadEventsByCompanies } from '../../../graph-ql/queries';
import { CreateEventInput } from '../../models/calendar/create-event.input';
import { EventForPlanningDto } from '../../models/calendar/event-for-planning.dto';
import { EventType } from '../../models/calendar/eventType';
import { EventTypes } from '../../models/calendar/eventTypes';
import { GetLeadEventsFilter } from '../../models/calendar/get-lead-events.filter';
import { GetLeadEventsInput } from '../../models/calendar/get-lead-events.input';
import { GetLeadEventsResponse } from '../../models/calendar/get-lead-events.response';
import { RemoveEventInput } from '../../models/calendar/remove-event.input';

@Injectable()
export class CalendarService {

  constructor(public apollo: Apollo) {
  }

  getEvents$(getLeadEventsInput: GetLeadEventsInput): Observable<GetLeadEventsResponse> {
    return this.apollo.query<GetLeadEventsResponse>({
      query: getLeadEvents,
      variables: {
        input: getLeadEventsInput
      }
    })
      .pipe(map(result =>
        new GetLeadEventsResponse(result.data['getLeadEvents']['events'], result.data['getLeadEvents']['businessHours'])
      ));
  }

  getEventsByCompanies$(getLeadEventsByCompaniesInput: GetLeadEventsInput): Observable<GetLeadEventsResponse> {
    return this.apollo.query<GetLeadEventsResponse>({
      query: getLeadEventsByCompanies,
      variables: {
        input: getLeadEventsByCompaniesInput
      }
    })
      .pipe(map(result => {
        return new GetLeadEventsResponse(result.data['getLeadEventsByCompanies']['events'], result.data['getLeadEventsByCompanies']['businessHours']);
      }
      ));
  }

  getEventsForDay$(getLeadEventsFilter: GetLeadEventsFilter): Observable<EventForPlanningDto[]> {
    return this.apollo.query<EventForPlanningDto[]>({
      query: getLeadEventsForDay,
      variables: {
        input: getLeadEventsFilter
      }
    })
      .pipe(map(result => {
        let eventResponse = new Array<EventForPlanningDto>();
        eventResponse = result.data['getLeadEventsForDay'].map(eventRaw => {
          return new EventForPlanningDto(eventRaw);
        });
        return eventResponse;

      }
      ));
  }

  getEventTypes(): Observable<EventTypes> {

    const dataFake = new EventTypes();
    const visit = new EventType();
    visit.id = 'visit';
    visit.backgroundColor = '#4F9EFF';
    visit.fontColor = '#FFF';
    const reminder = new EventType();
    reminder.id = 'reminder';
    reminder.backgroundColor = '#FFAE00';
    reminder.fontColor = '#FFF';
    dataFake.eventTypes = [
      visit, reminder
    ];

    return Observable.of(dataFake);
  }

  createEvent$(createEventInput: CreateEventInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: createEvent,
        variables: {
          input: createEventInput
        }
      });
  }
  createEventWithoutUser$(createEventInput: CreateEventInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: createEventWithoutUser,
        variables: {
          input: createEventInput,
        }
      });
  }

  removeEvent$(removeEventInput: RemoveEventInput): Observable<any> {
    return this.apollo
      .mutate<any>({
        mutation: removeEvent,
        variables: {
          input: removeEventInput
        }
      });
  }
}
